<template>
    <label class="form-label" :class="{ required }" v-if="label">{{ label }}</label>
    <input :id="id" ref="input" type="text" v-bind="$attrs" v-model.trim="text" />
</template>

<script setup>
    import Autocomplete from "bootstrap5-autocomplete";

    const { watchThrottled } = VueUse;

    const props = defineProps({
        items: { required: true, type: Array },
        label: { type: String },
        modelValue: { required: true, type: String },
        notFoundMessage: { type: String },
        required: { default: false, type: Boolean },
        searchFields: { type: Array },
        showAllSuggestions: { default: false, type: Boolean },
        threshold: { default: 1, type: Number }
    });

    const emit = defineEmits(["select", "update:modelValue"]);
    const id = nextId();
    const input = ref();
    const text = ref(props.modelValue);

    let instance;

    onMounted(() => {
        instance = new Autocomplete(input.value, {
            activeClasses: ["active"],
            fullWidth: true,
            items: props.items,
            searchFields: props.searchFields,
            showAllSuggestions: props.showAllSuggestions,
            suggestionsThreshold: props.threshold,
            onSelectItem: (item) => {
                input.value.blur();
                text.value = item.label;
                emit("select", item);
            }
        });
    });

    watch(() => props.items, () => {
        let item;

        if (text.value) {
            instance.setConfig("notFoundMessage", props.notFoundMessage);

            if (props.items.length === 1 && props.items[0].label === text.value) {
                item = props.items[0];
            }
        }

        instance.setData(props.items);

        if (!item) {
            instance.showOrSearch();
        }

        emit("select", item);
    });

    watch(() => props.modelValue, () => {
        text.value = props.modelValue;
    });

    watchThrottled(text, () => {
        instance.setConfig("notFoundMessage", "");

        emit("update:modelValue", text.value);
    }, {
        throttle: 500
    });
</script>
